<template>
    <div class="col-6  col-lg-3">
        <b-form-group :label="Label"  description="">
            <b-form-input  v-model="Wert"   disabled>
            </b-form-input>
        </b-form-group>
    </div>
</template>

<script>
//import { ro } from "../main";

export default {
  name: "AnalysenDetailFeld",
  props: {
    Label: String,
    Wert:[String, Number]
    },
  }

</script>